'use strict';
import { AdminLoader } from './loader';
import { suRouteGuard } from '../routes/routeGuards';
import { handleLazyLoadError } from '../helper/error-helper';

var AdminUrlsResolver = require('./getUrls');
var RoutePath = require('../constants/routePath');
var routerUtility = require('../utils/routerUtility');
var ModuleAccessCodes = require('../constants/moduleCodes');
var getAdminUrl = require('./getUrls');


module.exports = {
  path: getAdminUrl.getAdminModuleUrl(),

  indexRoute: {
    onEnter: function (nextState, replace) {
      replace(AdminUrlsResolver.getOrganisationUrl());
    }
  },
  getComponent(nextState, callback) {
    var error = routerUtility.getAccessError(ModuleAccessCodes.MODULE_ADMIN);
    if (error === null) {
      AdminLoader.load(callback).catch(handleLazyLoadError);
    } else {
      callback(error);
    }
  },
  getChildRoutes(partialNextState, callback) {
    require.ensure([],
      function (require) {
        callback(null, [
          {
            path: RoutePath.ROUTE_ADMIN_ORGANISATIONS,
            component: require('./views/organisations/organisationsPage')
          },
          {
            path: RoutePath.ROUTE_ADMIN_MODULES,
            component: require('./views/modules/modulesPage')
          },
          {
            path: RoutePath.ROUTE_ADMIN_BOOKS_SUBSCRIPTION,
            component: require('./views/schools/booksSubscriptionPage')
          },
          {
            path: RoutePath.ROUTE_ADMIN_INSPECTION_COACH,
            component: require('./views/inspectionCoach/inspectionCoachPage').default
          },
          {
            path: RoutePath.ROUTE_ADMIN_QUESTIONNAIRES,
            component: require('./views/questionnaires/questionnairesPage').default
          },
          {
            path: RoutePath.ROUTE_ADMIN_CONFIGURE_PLANS,
            component: require('./views/configurePlans/ConfigurePlansPage').default
          },
          {
            path: RoutePath.ROUTE_ADMIN_SECTOR_AREAS,
            component: require('./views/sectorAreas/sectorAreasPage')
          },
          {
            path: RoutePath.ROUTE_ADMIN_ACTIVITY_LOG,
            component: require('./views/activityLog/activityLogPage')
          },
          {
            path: RoutePath.ROUTE_ADMIN_FRAMEWORKS,
            component: require('./views/2bap/frameworks/FrameworkPage').FrameworkPage
          },
          {
            path: RoutePath.ROUTE_ADMIN_OBSERVATION_NOTES,
            component: require('./views/2bap/notes/ObservationNotesPage').ObservationNotesPage
          },
          {
            path: RoutePath.ROUTE_ADMIN_OBSERVATION_OBJECTIVES,
            component: require('./views/2bap/observationObjectives/ObservationObjectivesPage').ObservationObjectivesPage
          },
          {
            path: RoutePath.ROUTE_ADMIN_REPORT_TEMPLATES,
            component: require('./views/2bap/reportTemplates/ReportTemplatesPage').ReportTemplatesPage
          },
          {
            path: RoutePath.ROUTE_ADMIN_ASSESSMENT,
            component: require('./views/2bap/assessment/AssessmentConfigPage').AssessmentConfigPage
          },
          {
            path: RoutePath.ROUTE_ADMIN_PARENT_SHARE,
            component: require('./views/2bap/parentShare/ParentShareReviewProcessPage').ParentShareReviewProcessPage
          },
          {
            path: RoutePath.ROUTE_ADMIN_UPLOAD_FRAMEWORKS,
            component: require('./views/2bap/frameworks/FrameworkUploadPage').FrameworkUploadPage,
            onEnter: suRouteGuard
          },
          {
            path: RoutePath.ROUTE_ADMIN_2BAP_SETTINGS,
            component: require('./views/2bap/settings/SettingsPage').SettingsPage
          },
          {
            path: RoutePath.ROUTE_MY_PROFILE,
            component: require('../component/profile/profilePage')
          },
          {
            path: RoutePath.ROUTE_NOT_FOUND,
            component: require('../component/errors/notFoundPage')
          }
        ])
      },
      handleLazyLoadError,
      'admin')
  }
};
